import { withAnalytics } from 'components/common/analytics';
import { Input } from 'components/common/forms/input';
import { compose } from 'redux';

const enhance = compose(withAnalytics);
const InputContainer = enhance(Input);

export { InputContainer };
